function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 24,
  height: 24
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.697 15.89h2.617l-3.864 3.855v-2.608a1.25 1.25 0 0 1 1.247-1.247m2.863-9.774v8.896h-2.863a2.126 2.126 0 0 0-2.125 2.125V20H7.116A2.117 2.117 0 0 1 5 17.884V6.116A2.117 2.117 0 0 1 7.116 4h10.328a2.117 2.117 0 0 1 2.116 2.116m-9.317 5.102a1.22 1.22 0 0 0-1.23-1.23H7.837a.44.44 0 0 0-.44.44v3.144a.44.44 0 0 0 .44.439.446.446 0 0 0 .439-.44V12.44h.737a1.23 1.23 0 0 0 1.23-1.22m3.46-.008a1.22 1.22 0 0 0-1.221-1.221h-1.186a.44.44 0 0 0-.439.439v3.144a.44.44 0 0 0 .44.439h1.185a1.22 1.22 0 0 0 1.22-1.22zm3.486-.782a.44.44 0 0 0-.44-.44h-1.975a.44.44 0 0 0-.44.44v3.144a.439.439 0 1 0 .879 0v-1.133h1.019a.439.439 0 0 0 0-.878h-1.019v-.694h1.537a.446.446 0 0 0 .439-.44zm-8.176.44h-.737v.693h.737a.35.35 0 0 0 .351-.343.34.34 0 0 0-.35-.35m3.469 0h-.746v2.265h.746a.35.35 0 0 0 .342-.343v-1.58a.35.35 0 0 0-.342-.343",
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    fill: "#a93439",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "matrix(1.22 0 0 1.15 -2.562 -1.59)",
  vectorEffect: "non-scaling-stroke"
}));
export { SvgPdf as ReactComponent };
export default __webpack_public_path__ + "98f512ae8916df3b717439ddae91c11b.svg";